import { WarningState } from "@/frontend/SVGs/WarningState";
import { I18n } from "@/i18n/I18n";
import { ParameterType } from "@/types/parameterTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export function ParameterIsEmptyIcon(props: { placement?: 'top' | 'right', parameterType: ParameterType}) {
  const { placement, parameterType } = props;

  return (
    <OverlayTrigger
      placement={placement || 'top'}
      overlay={<Tooltip>
        {I18n.get('parameterIsEmpty', { type: I18n.get(parameterType) })}
      </Tooltip>}
    >
      <div className='text-warning'>
        <WarningState />
      </div>
    </OverlayTrigger>
  );
}